<div class="document-timeline">
  <!-- Empty State -->
  <div
    *ngIf="documentGroups.length === 0 && woundGroups.length === 0"
    class="empty-state"
  >
    <i class="fa-solid fa-folder-open empty-icon"></i>
    <p class="empty-text">{{ "documents.noDocuments" | translate }}</p>
  </div>

  <!-- Wound Groups -->
  <ng-container *ngIf="groupByWound">
    <div *ngFor="let group of woundGroups" class="timeline-group wound-group">
      <div
        class="group-header wound-header"
        [class.other-header]="group.woundId === 'unassigned'"
      >
        <div class="wound-info">
          <i class="fa-solid fa-notes-medical"></i>
          <span class="wound-title">
            {{
              group.woundId === "unassigned"
                ? ("documents.other" | translate)
                : (getStatusTranslationKey(group.woundStatus) | translate)
            }}
          </span>
          <span class="wound-date" *ngIf="group.woundId !== 'unassigned'">
            {{ group.woundCreatedDate | date : "dd.MM.yyyy" }}
          </span>
        </div>
      </div>

      <div class="document-list-container">
        <div *ngIf="group.documents.length === 0" class="empty-wound-docs">
          <i class="fa-solid fa-file-circle-minus"></i>
          <span>{{ "documents.noDocuments" | translate }}</span>
        </div>

        <ng-container
          *ngTemplateOutlet="
            documentList;
            context: { documents: group.documents }
          "
        ></ng-container>
      </div>
    </div>
  </ng-container>

  <!-- Date Groups (Default) -->
  <ng-container *ngIf="!groupByWound">
    <div *ngFor="let group of documentGroups" class="timeline-group">
      <div class="group-header">
        <div class="date-badge">
          <i class="fa-solid fa-calendar"></i>
          <span>{{ group.date | date : "dd.MM.yyyy" }}</span>
        </div>
      </div>
      <ng-container
        *ngTemplateOutlet="
          documentList;
          context: { documents: group.documents }
        "
      ></ng-container>
    </div>
  </ng-container>

  <!-- Reusable Document List Template -->
  <ng-template #documentList let-documents="documents">
    <div class="document-list">
      <div *ngFor="let doc of documents" class="document-item">
        <div class="document-icon">
          <i class="fa-solid" [ngClass]="getFileIcon(doc)"></i>
        </div>

        <div class="document-info">
          <p class="document-name" [title]="doc.originalFileName">
            {{ doc.originalFileName }}
          </p>
          <p class="document-meta">
            <span class="file-size">{{ formatFileSize(doc.fileSize) }}</span>
            <span class="separator">•</span>
            <span class="upload-time">{{
              doc.createdDate | date : "dd.MM.yyyy"
            }}</span>
            <span *ngIf="doc.uploadedByName" class="separator">•</span>
            <span *ngIf="doc.uploadedByName" class="uploader">{{
              doc.uploadedByName
            }}</span>
          </p>
        </div>

        <div class="document-actions">
          <button
            *ngIf="isPreviewable(doc)"
            type="button"
            class="action-btn preview-btn"
            [title]="'documents.preview' | translate"
            (click)="onPreview(doc)"
          >
            <i class="fa-solid fa-eye"></i>
          </button>
          <button
            type="button"
            class="action-btn download-btn"
            [title]="'documents.download' | translate"
            (click)="onDownload(doc)"
          >
            <i class="fa-solid fa-download"></i>
          </button>
          <button
            *ngIf="canDelete()"
            type="button"
            class="action-btn delete-btn"
            [title]="'documents.delete' | translate"
            (click)="onDelete(doc)"
          >
            <i class="fa-solid fa-trash"></i>
          </button>
        </div>
      </div>
    </div>
  </ng-template>

  <!-- Delete Document Modal -->
  <div
    class="modal fade"
    [id]="'deleteDocModal-' + deleteModalDocumentId"
    tabindex="-1"
    aria-labelledby="deleteDocModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-2" id="deleteDocModalLabel">
            {{ "documents.deleteDocument" | translate }}
          </h1>
          <button
            type="button"
            class="btn-close cursor-pointer"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body fs-4">
          {{ "documents.deleteConfirmation" | translate }}
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary cursor-pointer"
            data-bs-dismiss="modal"
          >
            {{ "cancel" | translate }}
          </button>
          <button
            type="button"
            class="btn btn-danger cursor-pointer"
            (click)="confirmDelete()"
            data-bs-dismiss="modal"
          >
            {{ "delete" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
